import type { KeyboardEvent, RefObject } from 'react';
import {
  isEnterOrSpace,
  isNavigationKey,
  isEscape,
  isArrowDown,
  handleMenuOpenRequest,
  handleMenuCloseRequest,
  handleArrowDownInMenu,
  handleEscapeInMenu,
  handleActivationInMenu,
  handleArrowNavigation,
  queryFocusableMenuElements,
} from './keyboardHelpers';

export { queryFocusableMenuElements };

export const createMenuButtonKeyHandler = (
  isMenuOpen: boolean,
  onMenuOpen: () => void,
  onMenuClose: () => void,
  menuRef?: RefObject<{ focusFirstMenuItem: () => void }>,
) => {
  return (event: KeyboardEvent) => {
    const { keyCode } = event;

    if (isMenuOpen) {
      if (isEnterOrSpace(keyCode) || isEscape(keyCode)) {
        handleMenuCloseRequest(event, onMenuClose);
      } else if (isArrowDown(keyCode) && menuRef?.current) {
        handleArrowDownInMenu(event, menuRef);
      }
    } else {
      if (isEnterOrSpace(keyCode) || isArrowDown(keyCode)) {
        handleMenuOpenRequest(event, onMenuOpen);
      }
    }
  };
};

export const createMenuKeyboardNavigationHandler = (
  onClose: () => void,
  containerRef: RefObject<HTMLElement>,
) => {
  return (event: KeyboardEvent) => {
    const { keyCode } = event;

    if (isEscape(keyCode)) {
      handleEscapeInMenu(event, onClose);
    } else if (isEnterOrSpace(keyCode)) {
      handleActivationInMenu(event);
    } else if (isNavigationKey(keyCode)) {
      handleArrowNavigation(event, containerRef);
    }
  };
};
